<template>
  <div>
    <Form ref="addModel" :model="addModel" :rules="ruleValidate" :label-width="120" >
      <FormItem label="权限名称" prop="privilegeName">
        <Input  v-model="addModel.privilegeName" placeholder="权限名称必须唯一"></Input>
      </FormItem>
      <FormItem label="权限值" prop="privilegeCode">
        <Input  v-model="addModel.privilegeCode"></Input>
      </FormItem>
      <FormItem label="权限类型" prop="privilegeType">
        <Select  v-model="addModel.privilegeType" clearable>
          <Option
            v-for="(item, index) in privilegeTypeSelect"
            :value="item.value"
            :key="index"
          >{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem label="描述信息">
        <Input
          v-model="addModel.privilegeDescription"
          type="textarea"
          :autosize="{minRows: 2,maxRows: 5}"
        ></Input>
      </FormItem>
    </Form>
    <div class="text-center modal-foter">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit('addModel')" class="mr-5">确 定</Button>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data: function () {
    return {
      organParentName: "",
      addModel: {
        privilegeName: "",
        privilegeCode: "",
        privilegeType: "",
        privilegeDescription: "",
      },
      privilegeTypeSelect: [],
      ruleValidate: {
        privilegeName: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        privilegeCode: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        privilegeType: [
          {
            required: true,
            message: "不能为空",
          },
        ],
      },
    };
  },

  created: function () {
    this.privilegeTypeSelect = this.$common.getJsonData("privilegeType");
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },

    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          this.$api.post("privilege/create", this.addModel).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("添加成功");
              this.returnBack();
              this.resetData();
              this.$emit("loadData");
            }
          });
        }
      });
    },

    resetData() {
      for (let key in this.addModel) {
        this.addModel[key] = "";
      }
      this.$refs["addModel"].resetFields();
    },
  },
};
</script>
<style scoped>
</style>